import { Link } from "react-router-dom"

const Canvas = () => {

    return (
        <div className="offcanvas__area">
            <div className="offcanvas__body">
                <div className="offcanvas__left">
                    <div className="offcanvas__logo">
                        <Link to="/">
                            <img src="/assets/imgs/logo/site-logo-white-2.png" alt="Offcanvas Logo" />
                        </Link>
                    </div>
                    <div className="offcanvas__social">
                        <h3 className="social-title">Follow Us</h3>
                        <ul>
                            <li><a href="https://www.linkedin.com/company/sacesta/">Linkedin</a></li>
                            <li><a href="https://www.instagram.com/sacesta_technologies/">Instagram</a></li>
                            {/* <!-- <li><a href="https://www.facebook.com/sacesta.in">Facebook</a></li> --> */}
                            <li><a href="https://twitter.com/SacestaTech">Twitter</a></li>
                            {/* <!-- <li><a href="https://www.youtube.com/@sacesta">YouTube</a></li> --> */}
                        </ul>
                    </div>
                    <div className="offcanvas__links">

                    </div>
                </div>
                <div className="offcanvas__mid">
                    <div className="offcanvas__menu-wrapper">
                        <nav className="offcanvas__menu">
                            <ul className="menu-anim">
                                <li className="has-megamenu">
                                    <Link to="/">Home</Link>
                                </li>
                                <li>
                                    <Link to="/about">about</Link>
                                </li>
                                <li className="has-megamenu">
                                    <Link to="/our-work">Our Work</Link>
                                </li>
                                {/* <!-- <li><a href="portfolio.php">Portfolio</a> -->
                            </li>
                            <!-- <li><a href="faq.php">FAQ's</a>
                            </li> -->
                            <!-- <li><a href="csr.php">CSR</a> -->
                            </li> */}
                                <li><a href="https://calendly.com/sacesta">Book A Call</a></li>

                            </ul>
                        </nav>
                    </div>
                </div>
                <div className="offcanvas__right">

                    <div className="offcanvas__search">

                    </div>
                    <div className="offcanvas__contact">
                        <h3>Get in touch</h3>
                        <ul>
                            <li><a href="tel:918347406455">+918347406455</a></li>
                            <li><a href="mailto:contact@sacesta.com">contact@sacesta.com</a></li>
                            <li>Ahmedabad Gujarat, India</li>
                        </ul>
                    </div>
                    <img src="/assets/imgs/shape/11.png" alt="shape" className="shape-1" />
                    <img src="/assets/imgs/shape/12.png" alt="shape" className="shape-2" />
                </div>
                <div className="offcanvas__close">
                    <button type="button" id="close_offcanvas"><i className="fa-solid fa-xmark"></i></button>
                </div>
            </div>
        </div>
    )
}

export default Canvas